import React from "react";
import UserDetail from "../directorate/user/user-detail/UserDetail";
import { useParams } from "react-router-dom";
import { useEffect } from "react";
import { getUsers } from "../util/http";
import { useState } from "react";

export default function UserDetailPage() {
  const params = useParams();
  const token = localStorage.getItem("token");
  const [progress, setProgress] = useState(0);
  const [user, setUser] = useState("");

  useEffect(() => {
    async function fetchData() {
      try {
        setProgress(20);
        setProgress(40);
        setProgress(60);
        const response = await getUsers(token, params.id);
        setProgress(80);
        setProgress(100);
        setUser(response?.user[0]);
      } catch (error) {
        setProgress(100);
      }
    }
    fetchData();
  }, []);
  return (
    <UserDetail progress={progress} setProgress={setProgress} user={user} />
  );
}
